'use client';

type AnalyticsEvent = {
  name: string;
  properties?: Record<string, unknown>;
  timestamp: number;
};

type AnalyticsTransport = (event: AnalyticsEvent) => void;

let transport: AnalyticsTransport | null = null;

export function configureAnalytics(nextTransport: AnalyticsTransport) {
  transport = nextTransport;
}

export function trackEvent(name: string, properties?: Record<string, unknown>) {
  const event: AnalyticsEvent = {
    name,
    properties,
    timestamp: Date.now(),
  };

  if (transport) {
    try {
      transport(event);
      return;
    } catch (error) {
      console.warn('Analytics transport failed', error);
    }
  }

  if (process.env.NODE_ENV !== 'production') {
    console.info('[analytics]', name, properties ?? {});
  }
}

export function useBootstrapTracker() {
  const start = performance.now();
  return {
    end(success: boolean, extra?: Record<string, unknown>) {
      const durationMs = performance.now() - start;
      trackEvent('bootstrap_completed', { success, durationMs, ...(extra ?? {}) });
    },
  };
}
